import {OrgCustomizedConfiguration} from '../OrgCustomizedConfiguration';
import MouthDiagramImg from './images/mouth-diagram.svg'
import IconImg from './images/imdi_icon.png'
import translations from '../../../localization/build/imdi.json'
import Theme from "./Theme";
import ThirdPartyProductError from "./ThirdPartyProductError";

const configuration: OrgCustomizedConfiguration = {
    OrgIdentifier: 'IMDI',
    OrgName: 'Implant Direct',
    HostsConfiguration: {
        'imdicomplaints.dev.platform.dental': {
            StoreUrl: 'https://imdi-sol.dev.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: 'Development',
        },
        'imdicomplaints.sta.platform.dental': {
            StoreUrl: 'https://imdi-sol.sta.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: 'Staging',
            GoogleAnalytics: {
                Id: 'GTM-NS6PVWMJ',
                Options: {
                    gtm_auth: 'dGZTp2lGw2jLev56AD8FjA',
                    gtm_preview: 'env-3',
                    gtm_cookies_win: 'x'
                }
            }
        },
        'complaints.implantdirect.com': {
            StoreUrl: 'https://store.implantdirect.com',
            IsDevelopmentEnvironment: false,
            Environment: 'Production',
            GoogleAnalytics: {
                Id: 'GTM-NS6PVWMJ'
            }
        },
        'localhost': {
            StoreUrl: 'https://imdi-sol.dev.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: 'Local',
        }
    },
    IconImage: IconImg,
    MuiTheme: Theme,
    ImageMap: {
        ProductLabel: undefined,
        MouthDiagram: {
            src: MouthDiagramImg,
        }
    },
    Translations: translations,
    SupportedLanguages: new Set(['en', 'de', 'es', 'fr', 'it', 'pt']),
    QuestionConfigurations: {
        patient_weight: {
            show: true,
            required: false
        },
        browse_for_photos: {
            required: false,
            show: true
        }
    },
    ItemSearchConfiguration: {
        useItemDescriptionSearch: (s) => /\D/.test(s) && s.length >= 3,
        useItemIdSearch: (s) => !/\D/.test(s) && s.length >= 4,
        useActiveProductSearch: (s) => s.length >= 3
    },
    GuestCountryWhitelist: [
        { countryCode: "az", languageCode: "az" },
        { countryCode: "cl", languageCode: "es" },
        { countryCode: "cn", languageCode: "zh" },
        { countryCode: "cr", languageCode: "es" },
        { countryCode: "hr", languageCode: "hr" },
        { countryCode: "cz", languageCode: "cs" },
        { countryCode: "eg", languageCode: "ar" },
        { countryCode: "ee", languageCode: "et" },
        { countryCode: "gr", languageCode: "el" },
        { countryCode: "iq", languageCode: "ar" },
        { countryCode: "il", languageCode: "he" },
        { countryCode: "jo", languageCode: "ar" },
        { countryCode: "kw", languageCode: "ar" },
        { countryCode: "lv", languageCode: "lv" },
        { countryCode: "lb", languageCode: "ar" },
        { countryCode: "lt", languageCode: "lt" },
        { countryCode: "om", languageCode: "ar" },
        { countryCode: "pl", languageCode: "pl" },
        { countryCode: "qa", languageCode: "ar" },
        { countryCode: "ro", languageCode: "ro" },
        { countryCode: "sa", languageCode: "ar" },
        { countryCode: "sg", languageCode: "en" },
        { countryCode: "za", languageCode: "en" },
        { countryCode: "tw", languageCode: "zh" },
        { countryCode: "tr", languageCode: "tr" },
        { countryCode: "ua", languageCode: "uk" },
        { countryCode: "ae", languageCode: "ar" },
    ],
    ThirdPartyErrorComponent: ThirdPartyProductError
}

export default configuration
